import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterInformationFields',
  pure: false
})
export class FilterInformationFieldsPipe implements PipeTransform {

  transform(allFields: any[], selectedFields: any[], currentField: any): any[] {
    return  allFields.filter(field => field === currentField ||
      !selectedFields.some(obj2 => obj2.informationfieldId === field.id.id));
  }
}
